const popupCloseBlock = (editor, options) => {
  const popupBlockOptions = options.blocks["popup-close"];
  const { name, label, category } = popupBlockOptions;

  const popupCloseStyles = options.components["popup-close"].style;

  const bm = editor.BlockManager;

  bm.add(name, {
    media: `<i class="fa fa-code"></i>`,
    label: `${label}`,
    category: category,
    content: {
      type: name,
      styles: popupCloseStyles
    }
  });
};

export default popupCloseBlock;